import styled from '@emotion/styled';
import { IButtonConfig, ButtonVariantStyles } from '@zeus/shared';
import { BaseLink } from '../../base/Link/BaseLink';
import { generateUrl, handleNavigationPreviewMode, ButtonVariant } from '../../sections/Commons';
import { UniversalLink } from '../UniversalLink';

interface ICtaButton {
  builderMode: boolean | undefined;
  previewMode: boolean | undefined;
  buttonConfig: IButtonConfig;
  buttonStyles: any;
  pageUrls: { [key: string]: string };
  onButtonClick?: (dataKey: string) => void;
  dataKey?: string;
  globalStyles?: {
    buttonVariants?: ButtonVariantStyles;
    buttonRadius?: number;
    bodyText?: {
      fontFamily?: string;
    };
  };
  localStyles?: {
    buttonVariants?: ButtonVariantStyles;
  };
  LinkComponent?: any;
}

const blockLinks = 'javascript:void(0)';

function CtaButton({
  builderMode,
  previewMode,
  buttonConfig,
  buttonStyles,
  pageUrls,
  globalStyles,
  localStyles,
  LinkComponent,
  onButtonClick,
  dataKey,
}: ICtaButton) {
  const handleButtonClick = (button: any, e?: React.MouseEvent) => {
    if (previewMode) {
      handleNavigationPreviewMode(button);
    }
    // Call onButtonClick in builder mode to notify parent about button click
    if (builderMode && !previewMode && onButtonClick && dataKey) {
      e?.preventDefault();
      e?.stopPropagation();
      onButtonClick(dataKey);
    }
  };

  // Get the button variant from config, default to PRIMARY
  const buttonVariant = buttonConfig?.variant?.value || ButtonVariant.PRIMARY;
  const dynamicButtonStyles = {
    ...buttonStyles,
    ...globalStyles?.buttonVariants?.[buttonVariant],
    ...localStyles?.buttonVariants?.[buttonVariant],
    borderRadius: globalStyles?.buttonRadius ? `${globalStyles.buttonRadius}px` : buttonStyles.borderRadius,
    fontFamily: globalStyles?.bodyText?.fontFamily || buttonStyles.fontFamily,
    borderColor: `${
      buttonStyles.borderColor ||
      localStyles?.buttonVariants?.[buttonVariant]?.borderColor ||
      globalStyles?.buttonVariants?.[buttonVariant]?.borderColor ||
      '#000'
    } !important`,
    maxWidth: '100%',
  };

  const StyledLink = styled(UniversalLink)`
    ${dynamicButtonStyles}
  `;

  const generatedUrl = generateUrl(buttonConfig, pageUrls);

  return (
    <>
      {!previewMode && !builderMode ? (
        <StyledLink
          LinkComponent={LinkComponent}
          target={buttonConfig?.internal ? '_self' : '_blank'}
          to={`${buttonConfig?.internal ? '/' : ''}` + `${generatedUrl}`}
        >
          {buttonConfig?.label}
        </StyledLink>
      ) : (
        <BaseLink
          href={builderMode ? blockLinks : `${buttonConfig?.internal ? '/' : ''}` + `${generatedUrl}`}
          target={builderMode || buttonConfig?.internal ? '_self' : '_blank'}
          onClick={(e) => {
            handleButtonClick(buttonConfig, e);
            if (builderMode && !previewMode) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
          sx={dynamicButtonStyles}
          role="button"
          aria-label={`${buttonConfig?.label}`}
        >
          {buttonConfig?.label}
        </BaseLink>
      )}
    </>
  );
}

export default CtaButton;
